<template>
    <v-col class="py-0 pt-2">
        <div class="d-flex">
            <v-icon color="black" class="mr-2">mdi-account</v-icon>
            <p class="subtitle-2 mt-1 mb-0">Name</p>
        </div>
        <div class="d-flex justify-space-between">
            <div class="d-flex">
                <p class="subtitle-1 mb-0 text-capitalize font-weight-bold d-inline-block text-truncate ellipsis">
                    {{ (recipientInfo.name || '').toLowerCase() }}
                </p>
                <v-tooltip bottom v-if="$vuetify.breakpoint.smAndDown">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            color="primary"
                            dark
                            v-bind="attrs"
                            v-on="on"
                            size="16"
                        >
                            mdi-information-outline
                        </v-icon>
                    </template>
                    <span>{{ recipientInfo.name }}</span>
                </v-tooltip>
            </div>

            <v-btn
                @click="copyToClipboard(recipientInfo.name)"
                absolute
                x-small
                class="warning copy-button"
            >
            Copy
            </v-btn>
        </div>
    </v-col>
</template>

<script>
    export default {
        name: "match-confirmed-reveal-field-name",
        props: {
            recipientInfo: Object
        }
    }
</script>

<style scoped>
    .v-tooltip__content.menuable__content__active {
        background: #333333;
        opacity: 1 !important;
    }
</style>
